import { ELkTypesActionTypes } from '../../actions/lkType/actions';
import { ILkTypeState } from '../../actions/lkType/types';
import { TReduxActions } from '../../types/redux';

export const lkTypeInitialState = {
  type: null,
};

export const lkTypeReducer = (state: ILkTypeState = lkTypeInitialState, action: TReduxActions): ILkTypeState => {
  switch (action.type) {
    case ELkTypesActionTypes.Set: {
      return {
        type: action.payload.lkType,
      };
    }
    default:
      return state;
  }
};
